export const environment = {
  production: false,
  url: "https://qa-api.answer5.msr-fsr.com",
  API_BASE_URL: "https://qa-api.answer5.msr-fsr.com",
  MESSAGE_URL: "https://qa-message.answer5.msr-fsr.com",
  backend: true,
  version: "v1",
  apiVersion: "1"
};
